module.exports = __webpack_public_path__ + "img/examination-pic3.3e6623e3.png";